import ExtendableError from './ExtendableError';
export default class TypeError extends ExtendableError {

}